import Dashboard from '../../../views/GMATFocus/Dashboard/dashboard';
import BeginChapters from '../../../views/GMATFocus/QuestionBank/Beginchapters';
import QuestionBank from '../../../views/GMATFocus/QuestionBank/QuestionBank';
import Readings from '../../../views/GMATFocus/QuestionBank/Readings';
import TwoStatement from '../../../views/GMATFocus/QuestionBank/SpecialQuestions/GMAT2Statement.js';
import Cases from '../../../views/GMATFocus/QuestionBank/SpecialQuestions/GMATCases';
import GMATMultipleStatement from '../../../views/GMATFocus/QuestionBank/SpecialQuestions/GMATMultipleStatement.js';
import Tab from '../../../views/GMATFocus/QuestionBank/SpecialQuestions/GMATTab.js';
import Table from '../../../views/GMATFocus/QuestionBank/SpecialQuestions/GMATTable.js';
import ViewQues from '../../../views/GMATFocus/QuestionBank/Viewques';
import BeforeStart from '../../../views/GMATFocus/Quizzes/BeforeStart';
import BeginCaseQuiz from '../../../views/GMATFocus/Quizzes/BeginQuiz/BeginQuizContainer.js';
import BeginGraphQuiz from '../../../views/GMATFocus/Quizzes/BeginQuiz/BeginQuizContainer.js';
import BeginTableQuiz from '../../../views/GMATFocus/Quizzes/BeginQuiz/BeginQuizContainer.js';
import BeginTabQuiz from '../../../views/GMATFocus/Quizzes/BeginQuiz/BeginQuizContainer.js';
import BeginTwoPartQuiz from '../../../views/GMATFocus/Quizzes/BeginQuiz/BeginQuizContainer.js';
import BeginQuiz from '../../../views/GMATFocus/Quizzes/BeginQuiz/BeginQuizContainer.js';
import Quizzes from '../../../views/GMATFocus/Quizzes/Quizzes';
import GMATVideoLessons from '../../../views/GMATFocus/VideoLessons/VideoLessons';
import VideoDisplay from '../../../views/GMATFocus/VideoLessons/videodisplay';
import appRoutes from './app-routes';

export const gmatFocusRoutes = [
  //^ ******* Dashboard ************ //
  {
    path: appRoutes.DASHBOARD,
    name: 'introduction',
    component: Dashboard,
  },
  //^ ******* Videos ************ //
  {
    path: appRoutes.VIDEO_DISPLAY,
    name: 'VIDEO_DISPLAY',
    component: VideoDisplay,
  },
  {
    path: appRoutes.VIDEO_LESSONS,
    name: 'VIDEO_LESSONS',
    component: GMATVideoLessons,
  },
  //^ ******* Question Bank ************ //
  {
    path: appRoutes.QUESTION_BANK,
    name: 'QUESTION_BANK',
    component: QuestionBank,
  },
  {
    path: appRoutes.QUESTION_BANK_READING,
    name: 'QUESTION_BANK_READING',
    component: Readings,
  },

  {
    path: appRoutes.QUESTION_BANK_VIEW_QUE,
    name: 'QUESTION_BANK_VIEW_QUE',
    component: BeginChapters,
  },

  {
    path: appRoutes.TWO_PART_STATEMENT,
    name: 'TWO_PART_STATEMENT',
    component: TwoStatement,
  },
  {
    path: appRoutes.GRAPH_MULTI_STATEMENT,
    name: 'GRAPH_MULTI_STATEMENT',
    component: GMATMultipleStatement,
  },

  { path: appRoutes.TAB, name: 'GMAT Tab', component: Tab },
  { path: appRoutes.TABLE, name: ' Table', component: Table },
  {
    path: appRoutes.QUESTION_BANK_LIST_QUE,
    name: 'Question Bank List',
    component: ViewQues,
  },
  //^ ******* Quizzes ************ //
  {
    path: appRoutes.BEGIN_CASE,
    name: 'Begin Case',
    component: Cases,
  },
  { path: appRoutes.QUIZZES, name: 'Quizzes', component: Quizzes },
  { path: appRoutes.QUIZZES_BEFORE_START, name: 'Before start', component: BeforeStart },
  { path: appRoutes.BEGIN_QUIZ, name: 'Begin quizzes', component: BeginQuiz },
  { path: appRoutes.BEGIN_CASE_QUIZ, name: 'Begin quizzes', component: BeginCaseQuiz },
  { path: appRoutes.QUIZZES_BEGIN, name: 'Begin quizzes', component: BeginTabQuiz },
  { path: appRoutes.BEGIN_TABLE_QUIZ, name: 'Begin quizzes', component: BeginTableQuiz },
  { path: appRoutes.BEGIN_GRAPH_QUIZ, name: 'Begin quizzes', component: BeginGraphQuiz },
  { path: appRoutes.BEGIN_TWO_PART_QUIZ, name: 'Begin quizzes', component: BeginTwoPartQuiz },

  //* ************* END ************************ //
];



// WEBPACK FOOTER //
// ./src/routes/exams/gmat-focus/index.js